module.exports = __webpack_public_path__ + "img/firma_template8.2a61c2a.svg";